import { connect } from 'react-redux';

const mapStateToProps = ({ ApplicantData }) => ({ ApplicantData });

export default (WrappedComponent) => connect(mapStateToProps, {})(WrappedComponent);
